import MeasurableQuickAddDialog from './MeasurableQuickAddDialog';

export default MeasurableQuickAddDialog;
